import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@youngcapital/component-library';
import { Trans } from 'react-i18next';
import contactEmailGenerator from '../../helpers/contactEmailGenerator';
import { AppContext } from '../../AppContext';

/* TODO: Test this function */
const sanitizePhone = (phoneNumber = '') =>
  phoneNumber.replace(/(?![\d+])./g, '');

const ContactCard = ({ t, signupFor }) => {
  const email = contactEmailGenerator();
  const { siteAbbr } = useContext(AppContext);
  const croReplacements = ['YC', 'YC_DE', 'YC_UK'].find(
    elem => elem === siteAbbr
  );
  const showContactCard = signupFor;
  const phone = t('fieldset_contact_card.phone');

  return (
    <>
      {showContactCard && !croReplacements && (
        <Card
          cardWrapperProps={{
            className: 'card--top mt-0'
          }}
        >
          <h3>{t('fieldset_contact_card.title')}</h3>
          <p>
            <Trans i18nKey='fieldset_contact_card.text' values={{ phone }}>
              contentPlaceholder
              <a href={`tel:${sanitizePhone(phone)}`} title='contact-phone'>
                phone
              </a>
              contentPlaceholder
            </Trans>
            <a href={`mailto:${email}`} title='contact-email'>
              {email}
            </a>
          </p>
        </Card>
      )}
    </>
  );
};

ContactCard.propTypes = {
  t: PropTypes.func.isRequired,
  signupFor: PropTypes.string.isRequired
};

export default ContactCard;
